import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import { ModalCargarConvenioPago } from "../Modales/ModalCargarConvenioPago";
// import { ModalDescargaArchivos } from "../Modales/ModalDescargaArchivos";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { DetalleClientesCard } from "../../../CreditoyCobranza/GestionCobranza/Components/DetalleClientesCard";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import WebAssetIcon from '@mui/icons-material/WebAsset';
import ModalGestionClienteJuridco from "../Modales/ModalGestionClienteJuridico";
import HomeIcon from '@mui/icons-material/Home';
import { TextField, MenuItem, InputAdornment, Modal, Box } from "@mui/material";
import { Email } from "@mui/icons-material";
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot, TimelineOppositeContent } from "@mui/lab";

export const DetalleClientesGestionarJuridicoScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [infoCliente, setInfoCliente] = useState([]);
    const [estadosCliente, setEstadosCliente] = useState([]);
    const [estadosDemanda, setEstadosDemanda] = useState([]);
    const [timelineCliente, setTimelineCliente] = useState([]);
    const [timelineDemanda, setTimelineDemanda] = useState([]);
    const [apartadoGestion, setApartadoGestion] = useState();
    const [actualiza, setActualiza] = useState(false);
    const [gestion, setGestion] = useState({
        idcliente: state.idcliente,
        estatus_cliente: 0,
        expediente: '',
        juzgado: '',
        estatus_demanda: 0,
        importe_convenio: 0,
        fecha_convenio: '',
        medio_contacto: '',
        fecha_visita: '',
        fecha_liquidacion: '',
        importe_liquidacion_pagado: 0,
        fecha_dacion: '',
        importe_dacion_valuado: 0,
        fecha_devolucion: '',
        importe_devolucion_valuado: 0
    });

    const [gestionDemanda, setGestionDemanda] = useState({
        idcliente: state.idcliente,
        estatus_demanda: 0,
    });


    const [folio, setFolio] = useState("");
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    // console.log(state)

    useEffect(() => {
        if (infoCliente.idestatus_cliente) {
            setGestion((prevGestion) => ({
                ...prevGestion,
                estatus_cliente: infoCliente.idestatus_cliente,
            }));
        }

        if (infoCliente.idestatus_demanda) {
            setGestion((prevGestion) => ({
                ...prevGestion,
                estatus_demanda: infoCliente.idestatus_demanda,
            }));
        }

        if (infoCliente.num_expediente) {
            setGestion((prevGestion) => ({
                ...prevGestion,
                expediente: infoCliente.num_expediente,
            }));
        }
        if (infoCliente.nombre_juzgado) {
            setGestion((prevGestion) => ({
                ...prevGestion,
                juzgado: infoCliente.nombre_juzgado,
            }));
        }

    }, [infoCliente]);

    // console.log(infoCliente)

    useEffect(() => {
        request
            .get(`DetalleClientesJuridico/EstadoClientesDDL`)
            .then((result) => {
                setEstadosCliente(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    }, []);

    useEffect(() => {
        request
            .get(`DetalleClientesJuridico/TimelineCliente?idregistro=${state.idregistro}`)
            .then((result) => {
                setTimelineCliente(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CLIENTE JURIDICO", JSON.stringify(error), "error");
            });
    }, [actualiza]);

    useEffect(() => {
        request
            .get(`DetalleClientesJuridico/TimelineDemanda?idregistro=${state.idregistro}`)
            .then((result) => {
                setTimelineDemanda(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CLIENTE JURIDICO", JSON.stringify(error), "error");
            });
    }, [actualiza]);

    // console.log(timelineCliente)

    useEffect(() => {
        request
            .get(`DetalleClientesJuridico/EstadoDemandaDDL`)
            .then((result) => {
                setEstadosDemanda(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    }, []);
    // console.log(estadosCliente)

    useEffect(() => {
        if (state.idcliente) {
            request
                .get(`DetalleClientesJuridico/InfoCliente?idcliente=${state.idcliente}`)
                .then((result) => {
                    setInfoCliente(result[0]);
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
                });
        }
    }, [actualiza]);

    // console.log(infoClkiente)

    const onGuardar = () => {
        if (apartadoGestion === undefined || apartadoGestion === null || apartadoGestion === "") {
            Swal.fire({
                title: "CONVENIO DE PAGO",
                text: "Selecciona un Apartado a Gestionar.",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return; // Detiene la ejecución si no hay facturas seleccionadas
        }
        if (gestion.expediente === null) {
            gestion.expediente = 0
        }
        setLoader({ ...loader, mostrar: true });
        const post = {
            idcliente: gestion.idcliente,
            estatus_cliente: gestion.estatus_cliente,
            expediente: gestion.expediente,
            juzgado: gestion.juzgado,
            estatus_demanda: gestion.estatus_demanda,
            importe_convenio: gestion.importe_convenio,
            fecha_convenio: gestion.fecha_convenio,
            medio_contacto: gestion.medio_contacto,
            fecha_visita: gestion.fecha_visita,
            fecha_liquidacion: gestion.fecha_liquidacion,
            importe_liquidacion_pagado: gestion.importe_liquidacion_pagado,
            fecha_dacion: gestion.fecha_dacion,
            importe_dacion_valuado: gestion.importe_dacion_valuado,
            fecha_devolucion: gestion.fecha_devolucion,
            importe_devolucion_valuado: gestion.importe_devolucion_valuado,
            apartado: apartadoGestion,
            usuario: 0
        };
        request
            .post(`DetalleClientesJuridico/Guardar`, post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                await Swal.fire({
                    title: "CONVENIO DE PAGO",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                setActualiza(prev => !prev);
            })
            // .then(async (result) => {
            //     return request.post(`ClientesResponsableCobranza/Guardar`, postresponsable);
            // })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    };

    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <PlantillaScreen
            titulo={'DETALLE DEL ESTADO DEL CLIENTE'}
            className={"detalle-juridico-main-screen"}
            className_main={1}
        >
            <LoaderScreen loader={loader} />
            <div className="detalle-juridico scroll-4">
                <div className="detalle-juridico-footer">
                    <div
                        className="detalle-juridico-footer-back"
                        onClick={() =>
                            history.push("/Credito/CobranzaJuridico")
                        }
                    >
                        <ArrowBackIcon /> Regresar
                    </div>
                </div>
                <div className="detalle-juridico-menu">
                    {/* Div izquierdo */}
                    <div className="detalle-juridico-menu-left">
                        <div className="detalle-juridico-menu-left-datos-cliente">
                            <div className="detalle-juridico-menu-left-datos-cliente-principales">
                                <p className="nombre-cliente"><strong>{state.razonsocial}</strong></p>
                                <p className="rfc-cliente"><strong>{infoCliente.rfc}</strong></p>
                                {/* <div className="datos-cliente-numeros">
                                    <p>No. Cliente en HumayaDigital: <strong>{infoCliente.idcliente}</strong></p>
                                    <p>No. Cliente en EQUIP: <strong>{infoCliente.idequip}</strong></p>
                                </div> */}
                            </div>

                            <div className="detalle-juridico-menu-left-datos-cliente-secundarios">
                                <div>
                                    <p className="domicilio-cliente"><HomeIcon /> Domicilio: <strong>{infoCliente.domicilio || 'Sin registrar'}</strong></p>
                                    <div className="datos-container">
                                        <div className="datos-juntos">
                                            <p><PhoneIcon /> Teléfono: <strong>{infoCliente.telefono || 'Sin registrar'}</strong></p>
                                            <p><EmailIcon /> Correo: <strong>{infoCliente.correo || 'Sin registrar'}</strong></p>
                                        </div>
                                        <div className="datos-juntos">
                                            <p>Importe Vencido: <strong>$ {infoCliente.importe_total_vencido}</strong></p>
                                            <p>Días Vencido: <strong>{infoCliente.dias_vencido} días</strong></p>
                                        </div>
                                        <div className="datos-juntos">
                                            <p>Fecha de Ingreso a Jurídico: <strong>{infoCliente.fecha_juridico}</strong></p>
                                            <p>Estado Actual: <strong>{infoCliente.estatus_cliente || 'Sin Asignar'}</strong></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="plantilla-screen-efecto">
                            <div className="plantilla-screen-efecto-bl"></div>
                            <div className="plantilla-screen-efecto-circle"></div>
                            <div className="plantilla-screen-efecto-br"></div>
                        </div>
                        <div className="detalle-juridico-menu-left-formulario">
                            <TextField
                                className="input-medio-comunicacion"
                                fullWidth
                                size="small"
                                label="Apartado a Gestionar"
                                select
                                value={apartadoGestion}
                                onChange={(e) => {
                                    setApartadoGestion(e.target.value,);
                                }}
                                sx={{ flex: 1, mr: 1, mt: 2 }}
                            >
                                <MenuItem value={'C'}>Cliente</MenuItem>
                                <MenuItem value={'D'}>Demanda</MenuItem>
                            </TextField>
                            {apartadoGestion === 'D' && (
                                <>

                                    <h3 className="titulo-form"><strong>Gestionar Demanda</strong></h3>
                                    <TextField
                                        className="input-medio-comunicacion"
                                        fullWidth
                                        size="small"
                                        label="Número de Expediente"
                                        value={gestion.expediente || ""}
                                        onChange={(e) => {
                                            setGestion({
                                                ...gestion,
                                                expediente: e.target.value,
                                            });
                                        }}
                                        sx={{ flex: 1, mt: 1 }}
                                    />
                                    <TextField
                                        className="input-medio-comunicacion"
                                        fullWidth
                                        size="small"
                                        label="Nombre del Juzgado"
                                        value={gestion.juzgado || ""}
                                        onChange={(e) => {
                                            setGestion({
                                                ...gestion,
                                                juzgado: e.target.value,
                                            });
                                        }}
                                        sx={{ flex: 1, mt: 2 }}
                                    />
                                    <TextField
                                        className="input-medio-comunicacion"
                                        fullWidth
                                        size="small"
                                        label="Estado de la Demanda"
                                        select
                                        value={gestion.estatus_demanda}
                                        onChange={(e) => {
                                            setGestion({
                                                ...gestion,
                                                estatus_demanda: e.target.value,
                                            });
                                        }}
                                        sx={{ flex: 1, mr: 1, mt: 2 }}
                                    >
                                        {estadosDemanda.map((estado) => (
                                            <MenuItem key={estado.idestado} value={estado.idestado}>
                                                {estado.descripcion_estadodemanda}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </>
                            )}
                            {apartadoGestion === 'C' && (
                                <>
                                    <h3 className="titulo-form"><strong>Gestionar Cliente</strong></h3>
                                    <TextField
                                        className="input-medio-comunicacion"
                                        fullWidth
                                        size="small"
                                        label="Estado del Cliente"
                                        select
                                        value={gestion.estatus_cliente}
                                        onChange={(e) => {
                                            setGestion({
                                                ...gestion,
                                                estatus_cliente: e.target.value,
                                            });
                                        }}
                                        sx={{ flex: 1, mr: 1, mt: 1 }}
                                    >
                                        {estadosCliente.map((estado) => (
                                            <MenuItem key={estado.idestado} value={estado.idestado}>
                                                {estado.descripcion_estadocliente}
                                            </MenuItem>
                                        ))}
                                    </TextField>


                                    {gestion.estatus_cliente === 2 && (
                                        <>
                                            <TextField
                                                className="input-medio-comunicacion"
                                                fullWidth
                                                size="small"
                                                label="Número de Expediente"
                                                value={gestion.expediente || ""}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        expediente: e.target.value,
                                                    });
                                                }}
                                                sx={{ flex: 1, mt: 2 }}
                                            />
                                            <TextField
                                                className="input-medio-comunicacion"
                                                fullWidth
                                                size="small"
                                                label="Nombre del Juzgado"
                                                value={gestion.juzgado || ""}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        juzgado: e.target.value,
                                                    });
                                                }}
                                                sx={{ flex: 1, mt: 2 }}
                                            />
                                            <TextField
                                                className="input-medio-comunicacion"
                                                fullWidth
                                                size="small"
                                                label="Estado de la Demanda"
                                                select
                                                value={gestion.estatus_demanda}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        estatus_demanda: e.target.value,
                                                    });
                                                }}
                                                sx={{ flex: 1, mr: 1, mt: 2 }}
                                            >
                                                {estadosDemanda.map((estado) => (
                                                    <MenuItem key={estado.idestado} value={estado.idestado}>
                                                        {estado.descripcion_estadodemanda}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </>
                                    )}
                                    {gestion.estatus_cliente === 3 && (
                                        <>
                                            <TextField
                                                className="input-medio-comunicacion"
                                                fullWidth
                                                size="small"
                                                label="Importe Conveniado"
                                                value={gestion.importe_convenio || ""}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        importe_convenio: e.target.value,
                                                    });
                                                }}
                                                sx={{ flex: 1, mt: 2 }}
                                            />
                                            <TextField
                                                size="small"
                                                type="date"
                                                fullWidth
                                                className="input-medio-comunicacion"
                                                label="Fecha de Convenio"
                                                value={gestion.fecha_convenio}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        fecha_convenio: e.target.value
                                                    });
                                                }}
                                                sx={{ flex: 1, mt: 2, mr: 1 }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start"></InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <TextField
                                                className="input-medio-comunicacion"
                                                fullWidth
                                                size="small"
                                                label="Medio de Contacto"
                                                select
                                                value={gestion.medio_contacto}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        medio_contacto: e.target.value,
                                                    });
                                                }}
                                                sx={{ flex: 1, mr: 1, mt: 2 }}
                                            >
                                                <MenuItem value={'T'}>Teléfono</MenuItem>
                                                <MenuItem value={'W'}>WhatsApp</MenuItem>
                                                <MenuItem value={'C'}>Correo</MenuItem>
                                            </TextField>
                                        </>
                                    )}
                                    {gestion.estatus_cliente === 4 && (
                                        <>
                                            <TextField
                                                size="small"
                                                type="date"
                                                fullWidth
                                                className="input-medio-comunicacion"
                                                label="Fecha de Visita"
                                                value={gestion.fecha_visita}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        fecha_visita: e.target.value
                                                    });
                                                }}
                                                sx={{ flex: 1, mt: 2, mr: 1 }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start"></InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </>
                                    )}
                                    {gestion.estatus_cliente === 5 && (
                                        <>
                                            <TextField
                                                size="small"
                                                type="date"
                                                fullWidth
                                                className="input-medio-comunicacion"
                                                label="Fecha de Liquidación"
                                                value={gestion.fecha_liquidacion}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        fecha_liquidacion: e.target.value
                                                    });
                                                }}
                                                sx={{ flex: 1, mt: 2, mr: 1 }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start"></InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <TextField
                                                className="input-medio-comunicacion"
                                                fullWidth
                                                size="small"
                                                label="Importe Pagado"
                                                value={gestion.importe_liquidacion_pagado || ""}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        importe_liquidacion_pagado: e.target.value,
                                                    });
                                                }}
                                                sx={{ flex: 1, mt: 2 }}
                                            />
                                        </>
                                    )}
                                    {gestion.estatus_cliente === 6 && (
                                        <>
                                            <TextField
                                                size="small"
                                                type="date"
                                                fullWidth
                                                className="input-medio-comunicacion"
                                                label="Fecha de Dación de Pago"
                                                value={gestion.fecha_dacion}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        fecha_dacion: e.target.value
                                                    });
                                                }}
                                                sx={{ flex: 1, mt: 2, mr: 1 }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start"></InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <TextField
                                                className="input-medio-comunicacion"
                                                fullWidth
                                                size="small"
                                                label="Importe Valuado"
                                                value={gestion.importe_dacion_valuado || ""}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        importe_dacion_valuado: e.target.value,
                                                    });
                                                }}
                                                sx={{ flex: 1, mt: 2 }}
                                            />
                                        </>
                                    )}
                                    {gestion.estatus_cliente === 7 && (
                                        <>
                                            <TextField
                                                size="small"
                                                type="date"
                                                fullWidth
                                                className="input-medio-comunicacion"
                                                label="Fecha de Devolución"
                                                value={gestion.fecha_devolucion}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        fecha_devolucion: e.target.value
                                                    });
                                                }}
                                                sx={{ flex: 1, mt: 2, mr: 1 }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start"></InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <TextField
                                                className="input-medio-comunicacion"
                                                fullWidth
                                                size="small"
                                                label="Importe Valuado"
                                                value={gestion.importe_devolucion_valuado || ""}
                                                onChange={(e) => {
                                                    setGestion({
                                                        ...gestion,
                                                        importe_devolucion_valuado: e.target.value,
                                                    });
                                                }}
                                                sx={{ flex: 1, mt: 2 }}
                                            />
                                        </>
                                    )}
                                </>
                            )}
                            <div className="detalle-juridico-button">
                                <button
                                    className="guardar-gestion-detalle-juridico"
                                    onClick={() => onGuardar()}
                                >
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="detalle-juridico-menu-right">
                        <div className="detalle-juridico-menu-right">
                            {timelineCliente && (
                                <div className="detalle-juridico-menu-right-timeline-cliente">
                                    <h3 className="titulo-form"><strong>Timeline del Cliente</strong></h3>
                                    <Timeline position="right">
                                        {timelineCliente.map((evento, index) => {
                                            // Determinar si este evento tiene la fecha más reciente
                                            const isMostRecent = evento.actualizacion === Math.max(...timelineCliente.map(e => e.actualizacion));

                                            return (
                                                <TimelineItem key={index}>
                                                    <TimelineOppositeContent color="text.secondary">
                                                        {evento.fecha}
                                                    </TimelineOppositeContent>
                                                    <TimelineSeparator>
                                                        <TimelineDot color={isMostRecent ? "success" : "grey"} />
                                                        {index < timelineCliente.length - 1 && <TimelineConnector />}
                                                    </TimelineSeparator>
                                                    <TimelineContent>
                                                        {evento.estatus === 1 || evento.estatus === 0 || evento.descripcion === "SIN ASIGNAR"
                                                            ? "Estado no registrado"
                                                            : `Se cambió el estado a ${capitalizeWords(evento.descripcion)}`}
                                                    </TimelineContent>
                                                </TimelineItem>
                                            );
                                        })}
                                    </Timeline>
                                </div>
                            )}

                            {/* Timeline de la Demanda */}
                            {timelineDemanda && (
                                <div className="detalle-juridico-menu-right-timeline-demanda">
                                    <h3 className="titulo-form"><strong>Timeline de la Demanda</strong></h3>
                                    <Timeline position="right">
                                        {timelineDemanda.map((evento, index) => {
                                            // Determinar si este evento tiene la fecha más reciente
                                            const isMostRecent = evento.actualizacion === Math.max(...timelineDemanda.map(e => e.actualizacion));

                                            return (
                                                <TimelineItem key={index}>
                                                    <TimelineOppositeContent color="text.secondary">
                                                        {evento.fecha}
                                                    </TimelineOppositeContent>
                                                    <TimelineSeparator>
                                                        <TimelineDot color={isMostRecent ? "success" : "grey"} />
                                                        {index < timelineDemanda.length - 1 && <TimelineConnector />}
                                                    </TimelineSeparator>
                                                    <TimelineContent>
                                                        {evento.estatus === 1 || evento.estatus === 0 || evento.descripcion === "SIN ASIGNAR"
                                                            ? "Estado no registrado"
                                                            : `Se cambió el estado a ${capitalizeWords(evento.descripcion)}`}
                                                    </TimelineContent>
                                                </TimelineItem>
                                            );
                                        })}
                                    </Timeline>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </PlantillaScreen >
    );
};
